import { addPlayerGroups, type User } from '@/api/auth';
import { useLocalStorageStore } from '@/store';
import { isUserAppropriateForTest } from './isUserAppropriateForTest';

const AB_TESTS_PREFIX = 'abtest';

export const syncUserGroupAndLSAbVersions = async (user: User) => {
  if (!user?.statuses) return;

  // sync user groups and LocalStorage
  const userVersions = user.statuses
    .filter(({ id }) => id.startsWith(AB_TESTS_PREFIX))
    .map(({ id }) => id);

  userVersions.forEach((version) => {
    const [experiment] = version.split(':');

    useLocalStorageStore.getState().replace(experiment, { name: version });
  });

  // sync LocalStorage and user groups
  const localStorageKeys = Object.keys(localStorage);
  const localStorageVersionsKeys = localStorageKeys.filter((key) =>
    key.startsWith(AB_TESTS_PREFIX)
  );

  const localStorageVersions = localStorageVersionsKeys
    .map((key) => useLocalStorageStore.getState().get<{ name: string }>(key))
    .filter(Boolean)
    .map(({ name }) => name)
    .filter(
      (name) =>
        !!name &&
        !userVersions.includes(name) &&
        isUserAppropriateForTest(name, user.createdAt)
    );

  if (!localStorageVersions.length) return;

  await addPlayerGroups(localStorageVersions);

  return true;
};
